import Vue from 'vue'
import Wedding from './Wedding.vue'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(Wedding)
})